// utils
import { apiConfig } from 'config';
import { AddOwnerInterface } from '../@types/owner';
import { WrapperService } from './wrapper';

export class OwnerService {
  public apiService: WrapperService = new WrapperService();

  getOwners(currentPage = 0, size: any = 10, filterName?: string, order?: string) {
    const apiParam = {
      method: 'GET',
      url: `/owner/all`,
      baseURL: apiConfig.asset_mgt,
      params: {
        page: currentPage,
        size,
        searchInput: filterName,
        sort: order
      }
    };
    return this.apiService.httpCall(apiParam);
  }

  deleteOwner(email: string) {
    const apiParam = {
      method: 'DELETE',
      url: `/owners`,
      baseURL: apiConfig.asset_mgt,
      params: { email: email }
    };
    return this.apiService.httpCall(apiParam);
  }

  getOwnerById(id: string) {
    const apiParam = {
      method: 'GET',
      url: `/owner/${id}`,
      baseURL: apiConfig.asset_mgt
    };
    return this.apiService.httpCall(apiParam);
  }

  getUnassignedOwner() {
    const apiParam = {
      method: 'GET',
      url: `/owner/unassigned`,
      baseURL: apiConfig.asset_mgt
    };
    return this.apiService.httpCall(apiParam);
  }

  updateOwner(formData: AddOwnerInterface) {
    const apiParam = {
      method: 'PUT',
      baseURL: apiConfig.asset_mgt,
      url: `/owner/${formData?.owner?.id}/update`,
      body: formData
    };
    return this.apiService.httpCall(apiParam);
  }
}
